import React from 'react';
export function ProblemSection() {
  return <section className="py-6 px-4 bg-gray-50" data-id="element-177">
      <div className="max-w-3xl mx-auto" data-id="element-178">
        <h2 className="text-[20px] font-black mb-4 text-center text-[#F9327E]" data-id="element-179">
          El problema que muchos docentes viven cada año
        </h2>

        <p className="text-xl mb-3 font-medium text-center md:text-left" data-id="element-180">
          Si sos docente de primaria seguramente esto te resulta familiar:
        </p>

        <ul className="space-y-2 text-lg text-gray-700 mb-5 max-w-2xl mx-auto" data-id="element-181">
          <li className="flex items-start" data-id="element-182">
            <span className="text-red-500 mr-3 font-bold text-xl" data-id="element-183">•</span>
            <span data-id="element-184">Pasás horas buscando efemérides en internet</span>
          </li>
          <li className="flex items-start" data-id="element-185">
            <span className="text-red-500 mr-3 font-bold text-xl" data-id="element-186">•</span>
            <span data-id="element-187">Tenés material guardado pero desordenado</span>
          </li>
          <li className="flex items-start" data-id="element-188">
            <span className="text-red-500 mr-3 font-bold text-xl" data-id="element-189">•</span>
            <span data-id="element-190">Preparás actividades a último momento</span>
          </li>
          <li className="flex items-start" data-id="element-191">
            <span className="text-red-500 mr-3 font-bold text-xl" data-id="element-192">•</span>
            <span data-id="element-193">
              Repetís propuestas porque no hay tiempo para buscar nuevas
            </span>
          </li>
          <li className="flex items-start" data-id="element-194">
            <span className="text-red-500 mr-3 font-bold text-xl" data-id="element-195">•</span>
            <span data-id="element-196">Los actos escolares se organizan sobre la marcha</span>
          </li>
        </ul>

        <p className="text-xl text-center mb-3 font-medium" data-id="element-197">
          Lo peor es esa sensación constante de pensar:
        </p>

        <div className="bg-white p-5 rounded-2xl shadow-lg border-l-8 border-yellow-400 text-center italic" data-id="element-198">
          <p className="text-2xl font-bold text-gray-800" data-id="element-199">
            "Podría trabajar mejor las efemérides… si tuviera todo el material
            organizado."
          </p>
        </div>
      </div>
    </section>;
}